import styled from "styled-components";

import { BoxFieldStyle, FieldTitleTextStyle } from "common/components";

import { ReactComponent as SearchIcon } from "assets/icons/icon-search-24.svg";
import { fieldHeight } from "common/const/const";

const SearchField = ({ placeholder, id, text }) => {
  return (
    <BoxFieldStyle>
      <FieldTitleTextStyle>{text || "Search"}</FieldTitleTextStyle>
      <SearchFieldStyle placeholder={placeholder} id={id} />
    </BoxFieldStyle>
  );
};

const SearchFieldStyle = styled.input`
  width: calc(100% - 2rem);
  height: ${fieldHeight};
  padding: 0;
  border: var(--border-width) solid var(--Gray);
  border-radius: var(--border-radius-8);
  padding-inline-start: 1rem;
  padding-inline-end: 1rem;

  font-size: var(--font-size-14);
  font-weight: var(--font-weight-regular);
  color: var(--DarkNavy);
`;

export { SearchField };
